module.exports = __webpack_public_path__ + "static/media/hourglass.bfe48f66.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hourglass.svg
// module id = 715
// module chunks = 11